import React, { } from "react";
import { useQuoteStore } from 'src/hooks/quote';
import Helper from 'src/helper/Helper';
import Constants from 'src/helper/Constants';
import useReduxState from "src/hooks/useReduxState";
import { useAxiosIndicatorCheck } from "src/store/hook/useAxiosIndicatorCheck";
import { useSystem } from "src/hooks/system";

const DeleteQuotePopup = (props) => {
    const { data, SetStatus } = props
    const [__check] = useAxiosIndicatorCheck();
    const quoteDetail = data && data.current_quote;
    const [{ }, { }, { single_delete_quote, set_is_success_action }] = useQuoteStore();
    const [, setDeleteFlag] = useReduxState(false, 'delectClicked')
    const onHide = () => {
        SetStatus(false)
    };
    const loader = __check('DELETE_QUOTE_API_CALL').status;
    const [,{ get_quantity_format }] = useSystem();

    const onDelete = async () => {
        const res = await single_delete_quote(quoteDetail.quoteLineItemId)
        if (res && res.isSuccessFull) {
            set_is_success_action(true)
            setDeleteFlag(true)
            onHide()
        }
    };


    const reuseDiv = (title) => (
        <tr>
            <td className="border-0">——</td>
            <td className="border-0">—— </td>
        </tr>
    );

    return (
        <>
            <div className="avnet-modal modal-500">
                <div className="avnet-modal-inner">
                    <button type="button" className="close py-3" data-dismiss="modal"
                            disabled={loader}
                        onClick={onHide}>×</button>
                    <div className="modal-header border-0">
                        <h3 className="modal-title m-auto" id="exampleModalLabel"><b>Remove this item from your quote?</b></h3>
                    </div>
                    <div className="modal-body">
                        {quoteDetail &&
                            <table className="table border-1 mb-0">
                                <thead>
                                    <tr>
                                        <th className='bg-grey2'>Part Number/Manufacturer  </th>
                                        <th className='bg-grey2'>Quantity </th>
                                        <th className='bg-grey2'>Target Unit Price</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {quoteDetail.quantity1 &&
                                        <tr>
                                            <td className="border-0" rowSpan="3">{quoteDetail.ERPMFRPartNumber} <br />
                                                By {quoteDetail.ManufacturerName}</td>
                                            <td className="border-0">{get_quantity_format(quoteDetail.quantity1)} </td>
                                            <td className="border-0">{Helper.valueIsNotNull(quoteDetail.targetUnitPrice) === false ? Constants.noValue : `$${quoteDetail.targetUnitPrice}`} </td>
                                        </tr>
                                    }
                                    {quoteDetail.quantity2 && quoteDetail.quantity2 > 0 ?
                                        <tr>
                                            <td className="border-0">{get_quantity_format(quoteDetail.quantity2)} </td>
                                            <td className="border-0">{Constants.noValue}</td>
                                        </tr> :
                                        reuseDiv()
                                    }
                                    {quoteDetail.quantity3 && quoteDetail.quantity3 > 0 ?
                                        <tr>
                                            <td className="border-0">{get_quantity_format(quoteDetail.quantity3)} </td>
                                            <td className="border-0">{Constants.noValue} </td>
                                        </tr> :
                                        reuseDiv()
                                    }
                                </tbody>
                            </table>
                        }
                    </div>
                    <div className="modal-footer d-flex justify-content-center">
                        <button type="button" className="bs5 btn btn-secondary w145"
                            disabled={loader}
                            onClick={onHide}>Cancel</button>
                        <button type="button" className="bs5 btn btn-primary w145"
                                disabled={loader}
                            onClick={() => onDelete()}>  {loader ? <i className="fa fa-spinner fa-spin" /> : "Remove"}</button>
                    </div>
                </div>
            </div>
        </>
    )
}

export default DeleteQuotePopup;